import {Controller} from "@hotwired/stimulus"

// Opens a modal on page load that asks the applicant to confirm the presenter requirements.
// The modal closes only after every checkbox is checked and the proceed button is clicked.
export default class extends Controller {
    static targets = ["checkbox", "proceed"]

    connect() {
        this.element.addEventListener("cancel", this.preventCancel)
        this.element.showModal()
        this.update()
    }

    disconnect() {
        this.element.removeEventListener("cancel", this.preventCancel)
    }

    // Keeps the Escape key from closing the modal without confirmation
    preventCancel = (event) => {
        event.preventDefault()
    }

    update() {
        this.proceedTarget.disabled = !this.checkboxTargets.every((checkbox) => checkbox.checked)
    }

    proceed() {
        this.element.close()
    }
}
